import toast from "react-hot-toast";
import * as api from "../Api";

export const approvedInvestments = () => async (dispatch) => {
  let fetchingId;
  try {
    fetchingId = toast.loading("Loading system data...");
    const { data } = await api.approvedInvestments();
    dispatch({ type: "GET_APPROVED", payload: data });
    toast.remove(fetchingId);
    toast.success("System data loaded");
  } catch (error) {
    toast.remove(fetchingId);
    toast.error(error.message);
  }
};
